import Vue from "vue";
import Router from "vue-router";
import Home from "@/components/Home";
import SignIn from "@/components/SignIn";
import SignUp from "@/components/SignUp";
import PasswordRecovery from "@/components/PasswordRecovery";
import ChangePassword from "@/components/ChangePassword";
import PanelControl from "@/components/PanelControl";
import NewShipmentFlowFromDashboard from "@/components/NewShipmentFlowFromDashboard";
import ShipmentsList from "@/components/ShipmentsList";
import ShipmentDetails from "@/components/ShipmentDetails";
import PaymentResult from "@/components/PaymentResult";
import Contact from "@/components/Contact";
import TermsAndConditions from "@/components/TermsAndConditions";
import PrivacyAdvice from "@/components/PrivacyAdvice";
import ThankPage from "@/components/ThankPage";
import FrequentQuestions from "@/components/FrequentQuestions";
import Integrations from "@/components/Integrations";
import Notifications from "@/components/Notifications";
import Reports from "@/components/Reports";
import Addresses from "@/components/Addresses";
import Etatistics from "@/components/Etatistics";
import Overweight from "@/components/Overweight";
import NewPrepaid from "@/components/NewPrepaid";
import ListPrepaid from "@/components/ListPrepaid";
import Users from "@/components/Users";
import Clients from "@/components/Clients";
import PaymentDetails from "@/components/PaymentDetails";
import Account from "@/components/MiCuenta";
import Company from "@/components/Compania";
import Recoleccion from "@/components/Recoleccion";
import TarificadorPersonalizado from "@/components/TarificadorPersonalizado";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
    },
    {
      path: "/signin",
      name: "SignIn",
      component: SignIn,
    },
    {
      path: "/signup",
      name: "SignUp",
      component: SignUp,
    },
    {
      path: "/password-recovery/:token",
      name: "ChangePassword",
      component: ChangePassword,
    },
    {
      path: "/password-recovery",
      name: "PasswordRecovery",
      component: PasswordRecovery,
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      component: PanelControl,
      // Todos los roles de usuario autenticado pueden acceder al PanelControl
      meta: {
        requiresAuth: true,
        roles: [
          "superadmin",
          "helpdesk",
          "sales",
          "client",
          "user",
          "admin",
          "admin_add",
        ],
      },
      redirect: "/dashboard",
      children: [
        {
          path: "/",
          component: Etatistics,
          meta: {
            roles: [
              "superadmin",
              "helpdesk",
              "sales",
              "client",
              "user",
              "admin",
              "admin_add",
            ],
          },
        },
        {
          path: "/extras",
          component: TarificadorPersonalizado,
          meta: {
            roles: [
              "client",
              "superadmin",
              "helpdesk",
              "sales",
              "user",
              "admin",
              "admin_add",
            ],
          },
        },
        {
          path: "/shipments",
          component: ShipmentsList,
          meta: {
            roles: [
              "client",
              "superadmin",
              "helpdesk",
              "sales",
              "user",
              "admin",
              "admin_add",
            ],
          },
        },
        {
          path: "/shipments/:id",
          component: ShipmentDetails,
          meta: {
            roles: [
              "client",
              "superadmin",
              "helpdesk",
              "sales",
              "user",
              "admin",
              "admin_add",
            ],
          },
        },
        {
          path: "/integrations",
          component: Integrations,
          meta: { roles: ["client", "superadmin", "admin_add"] },
        },
        {
          path: "/notifications",
          component: Notifications,
          meta: { roles: ["superadmin"] },
        },
        {
          path: "/reports",
          component: Reports,
          meta: {
            roles: [
              "client",
              "superadmin",
              "helpdesk",
              "sales",
              "admin",
              "admin_add",
            ],
          },
        },
        {
          path: "/addresses",
          component: Addresses,
          meta: {
            roles: [
              "client",
              "superadmin",
              "helpdesk",
              "sales",
              "user",
              "admin",
              "admin_add",
            ],
          },
        },
        {
          path: "/overweight",
          component: Overweight,
          meta: {
            roles: ["client", "superadmin", "helpdesk", "admin", "admin_add"],
          },
        },
        {
          path: "/dashboard/shipment/new",
          name: "NewShipmentFlowFromDashboard",
          component: NewShipmentFlowFromDashboard,
          meta: {
            roles: [
              "client",
              "superadmin",
              "sales",
              "user",
              "admin",
              "admin_add",
            ],
          },
        },
        {
          path: "/prepaids",
          name: "ListPrepaid",
          component: ListPrepaid,
          meta: { roles: ["client", "superadmin", "admin", "admin_add"] },
        },
        {
          path: "/prepaid/new",
          name: "NewPrepaid",
          component: NewPrepaid,
          meta: { roles: ["client", "superadmin", "admin", "admin_add"] },
        },
        {
          path: "/users",
          name: "Users",
          component: Users,
          meta: { roles: ["client", "superadmin", "sales", "admin_add"] },
        },
        {
          path: "/clients",
          name: "Clients",
          component: Clients,
          meta: { roles: ["superadmin"] },
        },
        {
          path: "/account",
          name: "Account",
          component: Account,
        },
        {
          path: "/company",
          name: "Company",
          component: Company,
        },
        {
          path: "/recoleccion",
          name: "Recoleccion",
          component: Recoleccion,
        },
      ],
    },
    {
      path: "/payments/result/:result",
      component: PaymentResult,
    },
    {
      path: "/payments/:id",
      component: PaymentDetails,
    },
    {
      path: "/contactanos",
      component: Contact,
    },
    {
      path: "/terminos-de-servicio",
      component: TermsAndConditions,
    },
    {
      path: "/politicas-de-privacidad",
      component: PrivacyAdvice,
    },
    {
      path: "/thank-page",
      component: ThankPage,
    },
    {
      path: "/preguntas-frecuentes",
      component: FrequentQuestions,
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  // 1. Obtener el rol del usuario desde localStorage
  const userRol = localStorage.getItem("ew-user-role");

  // Asumimos que cualquier ruta que está dentro de /dashboard requiere autenticación.
  // Pero revisaremos los roles si la ruta tiene el campo meta.roles.
  const requiredRoles = to.meta.roles;

  // Verifica si la ruta requiere roles específicos (y por ende, autenticación)
  if (requiredRoles) {
    // Si no hay rol, redirigir a inicio de sesión
    if (!userRol) {
      console.log("Acceso denegado: Usuario no autenticado.");
      // El rol no existe, redirigir a la página de inicio de sesión
      return next({ name: "SignIn" });
    }

    // 2. Verificar si el rol del usuario está permitido
    if (requiredRoles.includes(userRol)) {
      // El usuario tiene el rol permitido: continuar con la navegación
      next();
    } else {
      // El usuario está autenticado, pero NO tiene el rol requerido
      console.warn(
        `Acceso denegado: El rol '${userRol}' no puede acceder a ${to.path}.`
      );
      // Redirigir a una página de acceso denegado o al dashboard principal
      return next({ path: "/dashboard" });
    }
  } else {
    // 3. La ruta no tiene la propiedad `meta.roles` (es una ruta pública)
    next(); // Continuar la navegación sin restricciones
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js